// --------------------------------------------------------------
// Components
// --------------------------------------------------------------

// --------------------------------------------------------------
// Styles
// --------------------------------------------------------------

export default class Survey {
  constructor() {
    this.init();
  }

  init() {
    let appData;
    let numberOfSections = 0;
    let sectionCounter = 0;
    let allUserChoices = [];
    let surveyFieldsetErrorMsg = "";

    // Start Page Elements
    const startContainer = document.querySelector("[data-survey-page-start]");

    if (!startContainer) {
      // Stop init if not on page.
      return;
    }

    const startHeading = document.querySelector(
      "[data-survey-page-start-heading]"
    );
    // const startPreamble = document.querySelector("[data-survey-page-start-preamble]");
    const startSurveyBtn = document.querySelector(
      "[data-survey-page-start-btn]"
    );

    // Survey Page Elements
    const surveyContainer = document.querySelector("[data-survey-page]");
    const surveyHeading = document.querySelector("[data-survey-page-heading]");
    const surveySections = document.querySelector(
      "[data-survey-page-sections]"
    );
    const nextSectionBtn = document.querySelector(
      "[data-survey-page-section-next-btn]"
    );
    const prevSectionBtn = document.querySelector(
      "[data-survey-page-section-prev-btn]"
    );
    const surveyErrorMsg = document.querySelector(
      "[data-survey-page-error-msg]"
    );
    const surveyErrorMsgText = document.querySelector(
      "[data-survey-page-error-msg-text]"
    );
    const surveyErrorMsgBtn = document.querySelector(
      "[data-survey-page-error-msg-btn]"
    );

    // Result Page Elements
    const resultContainer = document.querySelector("[data-survey-page-result]");
    const resultHeading = document.querySelector(
      "[data-survey-page-result-heading]"
    );
    const resultPreamble = document.querySelector(
      "[data-survey-page-result-preamble]"
    );
    const resultSections = document.querySelector(
      "[data-survey-page-result-sections]"
    );
    const resultPageAdditionalInformation = document.querySelector(
      "[data-survey-page-additional-result-information]"
    );
    const restartBtn = document.querySelector(
      "[data-survey-page-result-restart-btn]"
    );
    const printBtn = document.querySelector(
      "[data-survey-page-result-print-btn]"
    );

    if (
      document.querySelector("[data-api-pageId]") != null &&
      document.querySelector("[data-api-url]") != null
    ) {
      const mainUrl =
        window.location.protocol + "//" + window.location.host + "/";
      const apiPageId = document
        .querySelector("[data-api-pageId]")
        .getAttribute("data-api-pageId");
      const apiUrl = document
        .querySelector("[data-api-url]")
        .getAttribute("data-api-url");
      const completeUrl = mainUrl + apiUrl + "?pageId=" + apiPageId;

      var getJSON = function (url) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);

        xhr.onload = function () {
          var status = xhr.status;
          if (status == 200) {
            const response = JSON.parse(xhr.responseText);
            appData = response.Result;
            let currentSurveyHeading = "";
            if (appData.SurveyPreHeadingLabel.length != 0) {
              currentSurveyHeading =
                "<span>" +
                appData.SurveyPreHeadingLabel +
                "</span>" +
                appData.SurveyHeading;
            } else {
              currentSurveyHeading = appData.SurveyHeading;
            }
            startHeading.innerHTML = currentSurveyHeading;
            surveyHeading.innerHTML = currentSurveyHeading;
            resultHeading.innerHTML = currentSurveyHeading;
            surveyErrorMsgText.innerText = appData.MandatoryErrorMessage;
            surveyFieldsetErrorMsg = appData.MandatoryStatementMessage;
            numberOfSections = appData.SurveyData.length;
          } else {
            console.error(status);
          }
        };
        xhr.send();
      };

      getJSON(completeUrl);

      // Click handler for the 'Start' button
      startSurveyBtn.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          renderAllSections();
          startContainer.style.display = "none";
          surveyContainer.style.display = "block";
          displayNextSection(sectionCounter);
        },
        false
      );

      // Click handler for the 'Next Section' button
      nextSectionBtn.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          validateSurveySection();
        },
        false
      );

      // Click handler for the 'Prev Section' button
      prevSectionBtn.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          surveyErrorMsg.style.display = "none";
          sectionCounter--;
          displayNextSection();
        },
        false
      );

      // Click handler for the 'Restart' button
      restartBtn.addEventListener("click", function (e) {
        e.preventDefault();
        sectionCounter = 0;
        allUserChoices = [];
        renderAllSections();
        resultContainer.classList.remove("visible");
        resultSections.innerHTML = "";
        surveyContainer.style.display = "block";
        displayNextSection();
      });

      // Click handler for the 'Print' button
      printBtn.addEventListener("click", function (e) {
        window.print();
      });

      window.addEventListener("scroll", function (e) {
        checkIsElementInView(".page--survey__fade-in-element", "visible");
      });

      window.addEventListener("resize", function (e) {
        checkIsElementInView(".page--survey__fade-in-element", "visible");
      });
    }

    // Creates all survey sections
    function renderAllSections() {
      surveySections.innerHTML = "";
      let surveySection = undefined;
      let surveySectionHeading = undefined;
      let surveySectionPreamble = undefined;
      let surveySectionStatements = undefined;
      let surveySectionStatementsContainer = undefined;

      for (let i = 0; i < numberOfSections; i++) {
        const currentSectionIndex = i;
        const currentSection = appData.SurveyData[i].SurveySection[0];
        surveySectionStatements = currentSection.Statements;
        surveySection = document.createElement("section");
        surveySection.setAttribute("data-section-" + currentSectionIndex, "");
        surveySection.setAttribute(
          "class",
          "page--survey__main-container__section"
        );

        surveySectionHeading = document.createElement("h3");
        surveySectionHeading.setAttribute("class", "h1");
        surveySectionHeading.innerHTML =
          "<span class='page--survey__main-container__section-counter'>Del " +
          (i + 1) +
          " av " +
          numberOfSections +
          "</span>" +
          currentSection.Heading;
        surveySection.appendChild(surveySectionHeading);

        if (
          currentSection.Preamble != undefined &&
          currentSection.Preamble.length != 0
        ) {
          surveySectionPreamble = document.createElement("p");
          surveySectionPreamble.setAttribute(
            "class",
            "page--survey__main-container__section__preamble"
          );
          surveySectionPreamble.innerText = currentSection.Preamble;
          surveySection.appendChild(surveySectionPreamble);
        }

        surveySectionStatementsContainer = document.createElement("div");

        for (let i = 0; i < surveySectionStatements.length; i++) {
          const statement = createStatementElement(
            i,
            currentSectionIndex,
            surveySectionStatements
          );
          surveySectionStatementsContainer.appendChild(statement);
        }

        surveySection.appendChild(surveySectionStatementsContainer);
        surveySections.appendChild(surveySection);
      }

      window.dataLayer.push({
        event: "surveyStart",
      });

      window._mtm = window._mtm || [];
      window._mtm.push({ event: "surveyStart" });
    }

    // Creates and returns a fieldset that contains the statement and the radio buttons
    function createStatementElement(
      index,
      currentSectionIndex,
      surveySectionStatements
    ) {
      const qElement = document.createElement("fieldset");
      qElement.setAttribute(
        "data-section-" + currentSectionIndex + "-fieldset-" + index,
        ""
      );
      qElement.setAttribute("class", "page--survey__fade-in-element");

      const question = document.createElement("legend");
      question.setAttribute("class", "h2");
      const questionText = surveySectionStatements[index].Statement.trim();
      question.innerText = questionText;
      qElement.appendChild(question);

      const radioButtons = createRadios(
        index,
        currentSectionIndex,
        surveySectionStatements
      );
      qElement.appendChild(radioButtons);

      return qElement;
    }

    // Creates a list of radio inputs
    function createRadios(
      statementIndex,
      sectionIndex,
      surveySectionStatements
    ) {
      const radioListContainer = document.createElement("div");
      radioListContainer.setAttribute("class", "page--survey__radio-list");
      const radioList = document.createElement("ul");
      let item = undefined;
      let input = undefined;
      let label = undefined;
      let labelSpan = undefined;
      let currentAnswer = undefined;
      let currentScore = undefined;
      for (
        let i = 0;
        i < surveySectionStatements[statementIndex].PossibleAnswers.length;
        i++
      ) {
        currentAnswer =
          surveySectionStatements[statementIndex].PossibleAnswers[
            i
          ].Answer.trim();
        currentScore =
          surveySectionStatements[statementIndex].PossibleAnswers[i].Score;
        item = document.createElement("li");
        input = document.createElement("input");
        label = document.createElement("label");
        label.setAttribute(
          "for",
          "section-" +
            sectionIndex +
            "-statement-" +
            statementIndex +
            "-option-" +
            currentScore
        );
        labelSpan = document.createElement("span");
        input.setAttribute("type", "radio");
        input.setAttribute(
          "id",
          "section-" +
            sectionIndex +
            "-statement-" +
            statementIndex +
            "-option-" +
            currentScore
        );
        input.setAttribute(
          "name",
          "section-" + sectionIndex + "-statement-" + statementIndex
        );
        input.setAttribute("value", currentAnswer);
        input.setAttribute("data-score", currentScore);
        input.addEventListener("click", function (e) {
          validateSingleFieldset(e);
        });
        labelSpan.innerText = currentAnswer;
        label.appendChild(labelSpan);
        item.appendChild(input);
        item.appendChild(label);
        radioList.appendChild(item);
      }

      const radioListErrorMsg = document.createElement("p");
      radioListErrorMsg.setAttribute("class", "page--survey__radio-list-error");
      radioListErrorMsg.innerText = surveyFieldsetErrorMsg;

      radioListContainer.appendChild(radioList);
      radioListContainer.appendChild(radioListErrorMsg);

      return radioListContainer;
    }

    function validateSingleFieldset(e) {
      const targetClassList = e.target.closest("fieldset").classList;
      if (targetClassList.contains("error")) {
        targetClassList.remove("error");
      }

      let numberOfSectionCheckedRadios = 0;
      const currentSectionStatementsLength =
        appData.SurveyData[sectionCounter].SurveySection[0].Statements.length;

      for (let i = 0; i < currentSectionStatementsLength; i++) {
        const currentFieldset = document.querySelector(
          "[data-section-" + sectionCounter + "-fieldset-" + i + "]"
        );
        const checkedRadio = currentFieldset.querySelector(
          "input[name='section-" +
            sectionCounter +
            "-statement-" +
            i +
            "']:checked"
        );
        if (checkedRadio != undefined) {
          numberOfSectionCheckedRadios++;
        }
      }

      if (
        numberOfSectionCheckedRadios === currentSectionStatementsLength &&
        nextSectionBtn.classList.contains("error")
      ) {
        nextSectionBtn.classList.remove("error");
      }
    }

    // Validates every input field of the current survey section
    function validateSurveySection() {
      let numberOfCheckedRadios = 0;
      const currentSectionStatementsLength =
        appData.SurveyData[sectionCounter].SurveySection[0].Statements.length;

      for (let i = 0; i < currentSectionStatementsLength; i++) {
        const currentFieldset = document.querySelector(
          "[data-section-" + sectionCounter + "-fieldset-" + i + "]"
        );
        const checkedRadio = currentFieldset.querySelector(
          "input[name='section-" +
            sectionCounter +
            "-statement-" +
            i +
            "']:checked"
        );
        if (checkedRadio != undefined) {
          numberOfCheckedRadios++;
        } else {
          currentFieldset.classList.add("error");
        }
      }

      if (numberOfCheckedRadios === currentSectionStatementsLength) {
        openErrorModal(false);
        saveUserChoices(currentSectionStatementsLength);
        sectionCounter++;
        displayNextSection();
      } else {
        openErrorModal(true);
      }
    }

    function lockTabbing(e) {
      surveyErrorMsgBtn.focus();
      if (
        e.keyCode === 9 &&
        document.body.classList.contains("survey-error-modal-open")
      ) {
        e.preventDefault();
        surveyErrorMsgBtn.focus();
      }
    }

    function openErrorModal(willOpen) {
      if (!willOpen) {
        nextSectionBtn.classList.remove("error");
        surveyErrorMsg.classList.remove("visible");
        document.body.classList.remove("survey-error-modal-open");
      } else {
        nextSectionBtn.classList.add("error");
        surveyErrorMsg.classList.add("visible");
        document.body.classList.add("survey-error-modal-open");
        surveyErrorMsgBtn.setAttribute("tabindex", 0);
        window.addEventListener("keydown", function (e) {
          lockTabbing(e);
        });
        surveyErrorMsgBtn.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            surveyErrorMsg.classList.remove("visible");
            document.body.classList.remove("survey-error-modal-open");
            window.removeEventListener("keydown", lockTabbing);
          },
          false
        );
      }
    }

    // Reads the user selection and pushes the value to an array
    function saveUserChoices(currentSectionStatementsLength) {
      // Array for user choices per category
      let sectionUserChoices = [];
      // Object containing the statement and the answer and score of the user choice
      class userChoiceObject {
        constructor(statement, userChoiceAnswer, userChoiceScore) {
          this.Statement = statement;
          this.UserChoiceAnswer = userChoiceAnswer;
          this.UserChoiceScore = userChoiceScore;
        }
      }
      // Get every user choice per category
      for (let i = 0; i < currentSectionStatementsLength; i++) {
        const fieldset = document.querySelector(
          "[data-section-" + sectionCounter + "-fieldset-" + i + "]"
        );
        const fieldsetStatement = fieldset.querySelector("legend").innerText;
        const fieldsetUserChoice = fieldset.querySelector(
          "input[name='section-" +
            sectionCounter +
            "-statement-" +
            i +
            "']:checked"
        );
        const fieldsetUserChoiceAnswer = fieldsetUserChoice.value;
        const fieldsetUserChoiceScore =
          fieldsetUserChoice.getAttribute("data-score");
        const singleUserChoice = new userChoiceObject(
          fieldsetStatement,
          fieldsetUserChoiceAnswer,
          fieldsetUserChoiceScore
        );
        sectionUserChoices.push(singleUserChoice);
      }

      // Update the array containing all user choices with current category user choices
      allUserChoices[sectionCounter] = sectionUserChoices;
    }

    // Displays next requested element
    function displayNextSection() {
      const currentSection = document.querySelector(
        "[data-section-" + sectionCounter + "]"
      );
      const prevSection = document.querySelector(
        "[data-section-" + (sectionCounter - 1) + "]"
      );
      const nextSection = document.querySelector(
        "[data-section-" + (sectionCounter + 1) + "]"
      );
      if (sectionCounter < numberOfSections) {
        if (prevSection !== null) {
          prevSection.classList.remove("visible");
        }
        if (nextSection !== null) {
          nextSection.classList.remove("visible");
        }
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
        currentSection.classList.add("visible");
        // Controls display of 'prev' button
        if (sectionCounter > 0) {
          prevSectionBtn.style.display = "block";
        } else {
          prevSectionBtn.style.display = "none";
          nextSectionBtn.style.display = "block";
        }
        if (sectionCounter + 1 < numberOfSections) {
          nextSectionBtn.innerHTML =
            "N\xE4sta del<i aria-hidden='true' class='icon fas fa-arrow-right'>";
        } else {
          nextSectionBtn.innerHTML =
            "Slutf\xF6r och visa resultat<i aria-hidden='true' class='icon fas fa-arrow-right'>";
        }
      } else {
        displayResults();
      }
    }

    // Computes score and returns a paragraph element to be displayed
    function displayResults() {
      surveyContainer.style.display = "none";
      resultPreamble.innerText = appData.SurveyResultDescription;

      if (appData.ResultPageAdditionalInformation.length != 0) {
        resultPageAdditionalInformation.setAttribute(
          "class",
          "page--survey__result-container__additional-material"
        );
        const resultPageAdditionalInformationHeading =
          document.createElement("h3");
        resultPageAdditionalInformationHeading.setAttribute(
          "class",
          "h1 page--survey__result-container__additional-material__headline"
        );
        resultPageAdditionalInformationHeading.innerHTML =
          appData.ResultPageAdditionalInformationHeading;
        const resultPageAdditionalInformationText = document.createElement("p");
        resultPageAdditionalInformationText.setAttribute(
          "class",
          "page--survey__result-container__additional-material__content"
        );
        resultPageAdditionalInformationText.innerHTML =
          appData.ResultPageAdditionalInformation;
        resultPageAdditionalInformation.appendChild(
          resultPageAdditionalInformationHeading
        );
        resultPageAdditionalInformation.appendChild(
          resultPageAdditionalInformationText
        );
      }

      let resultSection = undefined;
      let resultSectionHeading = undefined;
      let resultSectionAdditionalMaterial = undefined;

      // Renders every main section
      for (let i = 0; i < numberOfSections; i++) {
        const currentResultSectionIndex = i;
        const currentResultSection = appData.SurveyData[i].SurveySection[0];
        resultSection = document.createElement("section");
        resultSection.setAttribute(
          "class",
          "page--survey__result-container__section"
        );

        resultSectionHeading = document.createElement("h3");
        resultSectionHeading.setAttribute("class", "h1");
        resultSectionHeading.innerHTML =
          "<span>Del " + (i + 1) + "</span>" + currentResultSection.Heading;
        resultSection.appendChild(resultSectionHeading);

        let resultUnderSection = undefined;
        let resultUnderSectionHeading = undefined;
        let resultUnderSectionPreamble = undefined;

        const SurveyResultAnalysis = currentResultSection.SurveyResultAnalysis;

        // Renders every under section
        for (let i = 0; i < SurveyResultAnalysis.length; i++) {
          const currentResultUnderSection = SurveyResultAnalysis[i];
          const currentResultUnderSectionScoreGroup =
            currentResultUnderSection.ScoreGroup;

          resultUnderSection = document.createElement("section");
          resultUnderSection.setAttribute(
            "class",
            "page--survey__result-container__section__under-section"
          );
          resultUnderSectionHeading = document.createElement("h3");
          resultUnderSectionHeading.setAttribute("class", "h2");
          resultUnderSectionHeading.innerText =
            currentResultUnderSection.Heading;
          resultUnderSection.appendChild(resultUnderSectionHeading);

          if (
            currentResultUnderSection.Summary != undefined &&
            currentResultUnderSection.Summary.length != 0
          ) {
            resultUnderSectionPreamble = document.createElement("p");
            resultUnderSectionPreamble.setAttribute(
              "class",
              "page--survey__result-container__section__under-section__preamble"
            );
            resultUnderSectionPreamble.innerText =
              currentResultUnderSection.Summary;
            resultUnderSection.appendChild(resultUnderSectionPreamble);
          }

          for (let i = 0; i < currentResultUnderSectionScoreGroup.length; i++) {
            resultUnderSection.setAttribute(
              "data-result-under-section-" +
                currentResultSectionIndex +
                "-score-" +
                currentResultUnderSectionScoreGroup[i],
              ""
            );
          }

          resultSection.appendChild(resultUnderSection);
        }

        if (currentResultSection.AdditionalMaterial !== "") {
          resultSectionAdditionalMaterial = document.createElement("div");
          resultSectionAdditionalMaterial.setAttribute(
            "class",
            "page--survey__result-container__section__additional-material"
          );
          resultSectionAdditionalMaterial.innerHTML =
            currentResultSection.AdditionalMaterial;
          resultSection.appendChild(resultSectionAdditionalMaterial);
        }

        resultSections.appendChild(resultSection);
      }

      // Renders all user choices and appends them to correct under section
      for (let i = 0; i < allUserChoices.length; i++) {
        const currentUserChoiceSection = allUserChoices[i];
        const currentUserChoiceSectionIndex = i;
        let resultStatementWithAnswer = undefined;

        for (let i = 0; i < currentUserChoiceSection.length; i++) {
          const currentUserChoice = currentUserChoiceSection[i];
          const currentResultUnderSection = document.querySelector(
            "[data-result-under-section-" +
              currentUserChoiceSectionIndex +
              "-score-" +
              currentUserChoice.UserChoiceScore +
              "]"
          );
          resultStatementWithAnswer = document.createElement("div");
          resultStatementWithAnswer.setAttribute(
            "class",
            "page--survey__result-container__section__under-section__statement-with-answer"
          );
          switch (currentUserChoice.UserChoiceScore) {
            case "1":
              resultStatementWithAnswer.classList.add(
                "page--survey__result-container__section__under-section__statement-with-answer--high"
              );
              break;
            case "2":
              resultStatementWithAnswer.classList.add(
                "page--survey__result-container__section__under-section__statement-with-answer--medium-high"
              );
              break;
            case "3":
              resultStatementWithAnswer.classList.add(
                "page--survey__result-container__section__under-section__statement-with-answer--medium-low"
              );
              break;
            case "4":
              resultStatementWithAnswer.classList.add(
                "page--survey__result-container__section__under-section__statement-with-answer--low"
              );
              break;
            case "5":
              resultStatementWithAnswer.classList.add(
                "page--survey__result-container__section__under-section__statement-with-answer--unanswered"
              );
              break;
            default:
          }
          resultStatementWithAnswer.innerHTML =
            "<p class='page--survey__result-container__section__under-section__statement-with-answer__statement'>" +
            currentUserChoice.Statement +
            "</p><div class='page--survey__result-container__section__under-section__statement-with-answer__answer'><p>" +
            currentUserChoice.UserChoiceAnswer +
            "</p></div>";
          if (currentResultUnderSection != null) {
            currentResultUnderSection.appendChild(resultStatementWithAnswer);
            if (!currentResultUnderSection.classList.contains("visible")) {
              currentResultUnderSection.classList.add("visible");
            }
          }
        }
      }

      window._mtm = window._mtm || [];
      window._mtm.push({ event: "surveyComplete" });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "surveyComplete",
      });

      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
      resultContainer.classList.add("visible");
    }

    function checkIsElementInView(targetClass, activeClass) {
      const elements = document.querySelectorAll(targetClass);
      const elementsLength = elements.length;
      const windowHeight = window.innerHeight;
      const windowTop = window.pageYOffset;
      const windowBottom = windowTop + windowHeight;
      for (let i = 0; i < elementsLength; i++) {
        const trigger = elements[i].querySelector("ul");
        const triggerHeight = trigger.offsetHeight;
        const triggerTop = trigger.offsetTop;
        const triggerBottom = triggerTop + triggerHeight;
        if (windowBottom >= triggerTop && windowTop <= triggerBottom) {
          elements[i].classList.add(activeClass);
        }
      }
    }
  }
}
